import React from 'react';
import Chart from "react-apexcharts";
import { startCase } from 'lodash';

const PolarChart = (props) => {
    let summaryLogData = props.polarChartData;
    let labelData = [];
    let chartSeriesData = [];
    let skillwiseLogData = summaryLogData.outcome.skillwise;
    // console.log("skillwiseLogData=====>", skillwiseLogData);
    for (let i = 0; i < skillwiseLogData.length; i++) {
        let scoreData = ((+skillwiseLogData[i].score / +skillwiseLogData[i].totalAssets) * 100).toFixed(2);
        // if (scoreData > 0) {
            labelData.push(startCase(skillwiseLogData[i].name.split('_').join(' ')) + ' ' +scoreData + '%');
            chartSeriesData.push(scoreData);
        // }
    }
    // console.log("chartSeriesData=====>", chartSeriesData,"labelData===>",labelData);
    let chartOptions = {
        colors: [
            '#4B0082', '#C71585', '#2F4F4F', '#708090', '#D2691E', '#8B4513', '#A52A2A', '#00008B',
            '#A52A2A', '#800080', '#800000', '#008000', '#808000', '#FFC0CB', '#7FFFD4', '#808080',
            '#FF0000', '#00FFFF', '#FF00FF', '#36454F'
        ],
        stroke: {
            colors: ['#fff'],
        },
        fill: {
            opacity: 0.8
        },
        labels: labelData,        
        responsive: [{
            breakpoint: 480,
            options: {
                chart: {
                    width: 400,
                    type: 'polarArea'
                },
                legend: {
                    position: 'bottom'
                }
            }
        },{
            breakpoint: 1080,
            options: {
                chart: {
                    width: props.fromModl ? 500 : 200,
                    type: 'polarArea'
                },
                legend: {
                    show: props.fromModl ? true: false,
                    position: 'right'
                }
            }
        }]
    };

    return (
        <Chart
            options={chartOptions}
            series={chartSeriesData}
            type="polarArea"
        />
    );
};
export default PolarChart;
